import React from 'react'
import { createRoot } from 'react-dom/client';
import RtdGamePage from '../react-rtd-game/components/RtdGamePage';

// Render your React component instead
const root = createRoot(document.getElementById('app'));
root.render(<RtdGamePage />);

